(function () {
  var STORAGE_KEY = 'velmoraPopupDismissedUntil';
  var DAYS_TO_HIDE = 14;
  var DELAY_MS = 6000;

  function isDismissed() {
    try {
      var until = localStorage.getItem(STORAGE_KEY);
      return !!until && Date.now() < parseInt(until, 10);
    } catch (e) {
      return false;
    }
  }

  function setDismissedForDays() {
    try {
      var until = Date.now() + DAYS_TO_HIDE * 24 * 60 * 60 * 1000;
      localStorage.setItem(STORAGE_KEY, String(until));
    } catch (e) {}
  }

  function dismiss() {
    setDismissedForDays();
    var popup = document.getElementById('velmora-email-popup');
    if (popup) {
      popup.classList.remove('velmora-popup--open');
      popup.setAttribute('aria-hidden', 'true');
    }
  }

  function open() {
    var popup = document.getElementById('velmora-email-popup');
    if (!popup || popup.classList.contains('velmora-popup--open')) return;
    popup.classList.add('velmora-popup--open');
    popup.setAttribute('aria-hidden', 'false');
  }

  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('velmora-email-popup');
    if (!popup) return;

    var alreadyOpen = popup.classList.contains('velmora-popup--open');

    if (alreadyOpen) {
      setDismissedForDays();
    }

    popup.querySelectorAll('[data-velmora-popup-close]').forEach(function (el) {
      el.addEventListener('click', dismiss);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dismiss();
    });

    if (alreadyOpen || isDismissed()) return;

    setTimeout(function () {
      if (!isDismissed()) open();
    }, DELAY_MS);
  });
})();
